import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Outline_Width = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">📏 CSS Outline Width</h1>

      {/* Intro */}
      <p className="tutorial-intro">
        The <code>outline-width</code> property specifies the thickness of an
        element’s outline. It can take predefined keywords or custom values.
      </p>

      {/* Syntax */}
      <div className="tutorial-section">
        <h2 className="section-title">Syntax</h2>
        <CodeCopyBlock
          code={`selector {
  outline-width: thin | medium | thick | length;
}`}
        />
        <ul className="tutorial-list">
          <li>
            <code>thin</code> → usually <strong>1px</strong>
          </li>
          <li>
            <code>medium</code> → usually <strong>3px</strong> (default)
          </li>
          <li>
            <code>thick</code> → usually <strong>5px</strong>
          </li>
          <li>
            <code>length</code> → any custom value (e.g., <code>8px</code>,{" "}
            <code>0.2em</code>)
          </li>
        </ul>
      </div>

      {/* Examples */}
      <div className="tutorial-section">
        <h2 className="section-title">Examples</h2>
        <CodeCopyBlock
          code={`p.thin {
  outline: solid red thin;
}

p.medium {
  outline: solid blue medium;
}

p.thick {
  outline: solid green thick;
}

p.custom {
  outline: solid purple 8px;
}`}
        />

        {/* Live Demo */}
        <p
          style={{
            border: "2px solid #333",
            outline: "red solid thin",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          Thin outline
        </p>
        <p
          style={{
            border: "2px solid #333",
            outline: "blue solid medium",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          Medium outline
        </p>
        <p
          style={{
            border: "2px solid #333",
            outline: "green solid thick",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          Thick outline
        </p>
        <p
          style={{
            border: "2px solid #333",
            outline: "purple solid 8px",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          Custom 8px outline
        </p>
      </div>

      {/* Description */}
      <div className="tutorial-section">
        <h2 className="section-title">Important Notes</h2>
        <ul className="tutorial-list">
          <li>Outline width works only when an outline style is set.</li>
          <li>It applies to all sides equally (no per-side control).</li>
          <li>Useful for highlighting focus or selection states.</li>
        </ul>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">Next Steps</h2>
        <p>
          After learning about <strong>outline-width</strong>, check out{" "}
          <a href="/css/outline-color" className="learn-more">
            Outline Color
          </a>{" "}
          to see how to customize outline appearance further.
        </p>
      </div>
    </div>
  );
};

export default Outline_Width;
